import { useContext } from 'react';
import { modalContext } from '@Hooks/modalManager/modalContext.ts';

export const useModal = () => {
  const modalCtx = useContext(modalContext);
  const { setModal, state } = modalCtx;

  return {
    modalState: state,
    setModal,
  };
};
